import ApiResource from './ApiResource';

class ZendeskResource extends ApiResource {
  public endpoint = '/metadata';
}

export const zendeskResource = new ZendeskResource();
